import React from 'react';
import { AI } from '@/constants/testIds';

export default function AIAnalysisModal({ open, form, setForm, onSubmit, onClose, onImageUpload, loading, result }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-6">
      <div className="bg-white rounded-sm max-w-3xl w-full max-h-[90vh] overflow-y-auto p-8">
        <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Outfit' }}>AI Analysis</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-black mb-2">Analysis Type</label>
            <select
              data-testid={AI.typeSelect}
              value={form.analysis_type}
              onChange={(e) => setForm({ ...form, analysis_type: e.target.value })}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
            >
              <option value="defect">Defect Analysis</option>
              <option value="cost">Cost Estimation</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-black mb-2">Description</label>
            <textarea
              data-testid={AI.descriptionInput}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
              rows="4"
              placeholder="Describe the defect or project details..."
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-black mb-2">Upload Image (Optional)</label>
            <input
              data-testid={AI.uploadImage}
              type="file"
              accept="image/*"
              onChange={onImageUpload}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm"
            />
          </div>
          {loading && (
            <div className="flex items-center gap-3 p-4 bg-blue-50 border border-blue-200 rounded-sm">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
              <span className="text-sm text-blue-800">Analyzing with AI...</span>
            </div>
          )}
          {result && (
            <div data-testid={AI.result} className="p-6 bg-slate-50 border border-slate-200 rounded-sm">
              <h3 className="text-lg font-semibold mb-3" style={{ fontFamily: 'Outfit' }}>Analysis Result</h3>
              <div className="prose prose-sm max-w-none text-slate-700 whitespace-pre-wrap">
                {result}
              </div>
            </div>
          )}
          <div className="flex gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-slate-300 rounded-sm hover:bg-slate-50 transition-all"
            >
              Close
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-sm hover:bg-blue-700 transition-all disabled:opacity-50"
            >
              {loading ? 'Analyzing...' : 'Analyze'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
